import React, { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { MyTextInput } from "../services/authentication/inputServices";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Store } from "react-notifications-component";
import { change_pass } from "../services/web/webServices";

function ChangePassword() {
  const navigate = useNavigate();
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const [getButton, setButton] = useState(true);

  const [oldPassword, setOldPassword] = useState(false);
  const [Password, setPassword] = useState(false);
  const [ConfirmPassword, setConfirmPassword] = useState(false);

  const toggleOldPasswordVisibility = () => {
    setOldPassword(!oldPassword);
  };

  const toggleNewPasswordVisibility = () => {
    setPassword(!Password);
  };

  const toggleConfirmPasswordVisibility = () => {
    setConfirmPassword(!ConfirmPassword);
  };

  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const pageName = "Change Password";

  const css = `
.form-container {
  width: 700px;
  marginTop:60px;
  padding: 40px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #f0f0f0;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
 .form-label {
  margin-bottom: 5px;
  display: block;
  color: #555659; 
}
input[type='text'],
input[type="password"],
input[type='email'] {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  
}
.password-input {
  position: relative;
  margin-bottom: 16px;
}
.toggle-password {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #666;
}

}
  `;
  return (
    <>
      <style>{css}</style>
      <div className="grid-container">
        <Sidebar
          openSidebarToggle={openSidebarToggle}
          OpenSidebar={OpenSidebar}
        />
        <Header OpenSidebar={OpenSidebar} pageName={pageName} />
        <div
          style={{
            gridArea: "main",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div className="form-container">
            <h2 style={{ marginBottom: "50px" }}>Change Password</h2>
            <Formik
              enableReinitialize={true}
              initialValues={{
                password: "",
                old_password: "",
                confirm_password: "",
              }}
              validationSchema={Yup.object({
                password: Yup.string()
                  .required("New Password is required")
                  .min(8, "Password must be at least 8 characters long")
                  .max(20, "Password cannot exceed 20 characters"),

                old_password: Yup.string().required("Old Password is required"),
                confirm_password: Yup.string()
                  .oneOf([Yup.ref("password"), null], "New Password and Confirm Password must match")
                  .required("Confirm password is required")
                  .min(8, "Confirm Password must be at least 8 characters long")
                  .max(20, "Confirm Password cannot exceed 20 characters"),
              })}
              onSubmit={(values, { resetForm }) => {
                const { confirm_password, ...dataToSend } = values; // Exclude confirm_password
                setButton(false);
                change_pass(dataToSend)
                  .then((res) => {
                    setButton(true);

                    Store.addNotification({
                      title: "Success",
                      message: res?.data?.message,
                      type: "success",
                      insert: "top",
                      container: "top-right",
                      animationIn: ["animate__animated", "animate__fadeIn"],
                      animationOut: ["animate__animated", "animate__fadeOut"],
                      dismiss: {
                        duration: 5000,
                        onScreen: true,
                      },
                    });
                    resetForm({ values: "" });
                  })
                  .catch((err) => {
                    setButton(true);
                    if (err) {
                      Store.addNotification({
                        title: "Error!",
                        message: err?.response?.data?.message,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                          duration: 5000,
                          onScreen: true,
                        },
                      });
                    }
                  });
              }}
            >
              {(props) => (
                <Form>
                  <div className="form-group">
                    <label htmlFor="old_password" className="form-label">
                      {" "}
                      Old Password
                    </label>
                    <div className="password-input">
                      <MyTextInput
                        type={oldPassword ? "text" : "password"}
                        name="old_password"
                        placeholder="Enter Your Old Password"
                      />

                      <span
                        className="toggle-password"
                        onClick={toggleOldPasswordVisibility}
                      >
                        {oldPassword ? "Hide" : "Show"}
                      </span>
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="password" className="form-label">
                      New Password
                    </label>
                    <div className="password-input">
                      <MyTextInput
                        type={Password ? "text" : "password"}
                        name="password"
                        placeholder="Enter Your New Password"
                      />
                      <span
                        className="toggle-password"
                        onClick={toggleNewPasswordVisibility}
                      >
                        {Password ? "Hide" : "Show"}
                      </span>
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="confirm_password" className="form-label">
                      Confirm Password
                    </label>

                    <div className="password-input">
                      <MyTextInput
                        type={ConfirmPassword ? "text" : "password"}
                        name="confirm_password"
                        placeholder="Enter Confirm Password"
                      />
                      <span
                        className="toggle-password"
                        onClick={toggleConfirmPasswordVisibility}
                      >
                        {ConfirmPassword ? "Hide" : "Show"}
                      </span>
                    </div>
                  </div>
                  {getButton === true ? (
                    <button
                      type="submit"
                      style={{
                        padding: "12px",
                        backgroundColor: "#076A33",
                        width: "620px",
                        border: "700px",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontSize: "16px",
                        fontSize: "20px", // Increased font size
                        color: "#fff", // White text color
                        // border: "none", // Remove border if not needed
                      }}
                    >
                      Submit
                    </button>
                  ) : (
                    <button
                      type="submit"
                      style={{
                        padding: "12px",
                        backgroundColor: "#076A33",
                        width: "620px",
                        border: "700px",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontSize: "16px",
                        fontSize: "20px", // Increased font size
                        color: "#fff", // White text color
                      }}
                    >
                      {" "}
                      Please Wait...
                    </button>
                  )}
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
}

export default ChangePassword;
